export class Paths {
  static readonly ODO_SELF_ASSESSMENT = "/elearning/self-assessment";
  static readonly ODOPRO = "/odopro/";
  static readonly CONVERSATIONAL = "/conversational/";
}
